import { useLocation, useParams } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";
import { useEffect, useState } from "react";
import TransferCustomer from "../../../components/modals/users/TransferCustomer";
import ModalContainer from "../../../components/modals/ModalContainer";
import { useDispatch, useSelector } from "react-redux";
import { getUserCustomers } from "../../../redux/slice/user/userSlice";
import { BounceLoader } from "react-spinners";

const AgentCustomers = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { user_customers, isLoading } = useSelector((state) => state?.user);

  const [searchBy, setSearchBy] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const breadcrumb = {
    from: {
      title: "User Profile",
      link: `/admin/user/user-profile/${id}`,
    },
    current: {
      title: "View Customers",
      link: null,
    },
  };

  // Toggle individual row selection
  const handleRowCheckboxChange = (uuid) => {
    setSelectedIds((prev) =>
      prev.includes(uuid)
        ? prev.filter((selectedId) => selectedId !== uuid)
        : [...prev, uuid]
    );
  };

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchBy.length) {
          const payload = {
            id: state.id.id,
            searchBy
          }
          dispatch(getUserCustomers(payload))
        }
      }   


  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      setSelectedIds(user_customers.map((customer) => customer.customer_uuid));
    }
    setSelectAll(!selectAll);
  };


    useEffect(() => {
        setSelectAll(user_customers.length > 0 && selectedIds.length === user_customers.length);
    }, [selectedIds, user_customers]);

    useEffect(() => {
        if (!searchBy) {
        dispatch(getUserCustomers({ id: state.id, searchBy: "" }));
        }
    }, [dispatch, searchBy, state]);

  return (
    <div>
        <PageTitle title="View Customers" breadcrumb={breadcrumb} /> 
        <div className="row mt- card p-1">
            <div className="row mb-3">
            <div className="d-flex justify-content-between align-items-center py-2 my-2">
                <h4 className="text-primary-1">Customers</h4>
                <button
                data-bs-toggle="modal"
                data-bs-target="#transfer"
                className="btn btn-sm btn-primary m-0 px-2"
                disabled={selectedIds.length === 0}
                >
                Transfer
                </button>
            </div>
            <div className="d-flex justify-content-end">
                <form className="d-flex bg-primary-1 align-items-center" style={{ height: "30px", width: "217px" }} onSubmit={handleSearch}>
                <input
                    type="search"
                    value={searchBy}
                    className="border-0"
                    placeholder="Search..."
                    onChange={(e) => setSearchBy(e.target.value)}
                    style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                />
                <button type="submit" className="btn btn-primary btn-sm d-flex align-items-center gap-1" style={{ height: "28px" }}>
                    <i className="uil uil-search text-white fs-4"></i>
                </button>
                </form>
            </div>
            </div>

            {/* Table */}
            <div className="row">
                <div className="col-sm-12">
                    {(user_customers?.length < 1 && !isLoading) ? (
                        <h5 className='alert alert-info'>Result not found!</h5>
                    ) : (
                        <div className="table-responsive">
                        <table className="table table-centered table-striped nowrap w-100 no-footer">
                            <thead>
                            <tr>
                                <th className="text-center">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                />
                                </th>
                                <th>Status</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Customer Type</th>
                                <th>Customer ID</th>
                                <th>State</th>
                                <th>Phone Number</th>
                                <th>Date Registered</th>
                            </tr>
                            </thead>
                            <tbody>
                            {user_customers.map((customer) => (
                                <tr key={customer.customer_uuid}>
                                  <td className="text-center">
                                      <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={selectedIds.includes(customer.customer_uuid)}
                                      onChange={() => handleRowCheckboxChange(customer.customer_uuid)}
                                      />
                                  </td>
                                  <td>
                                    <span
                                      className={`badge ${
                                        customer?.customer_status === "1" &&
                                        "badge-warning-lighten"
                                      } ${
                                        customer?.customer_status === "2" &&
                                        "badge-success-lighten"
                                      } ${
                                        customer?.customer_status === "3" && "badge-danger-lighten"
                                      } ${
                                        customer?.customer_status === "4" &&
                                        "badge-secondary-lighten"
                                      } fw-normal rounded-4`}
                                      style={{
                                        fontSize: "10px",
                                        padding: "5px 18px",
                                      }}
                                    >
                                      {customer?.customer_status === "1" && "Pending Approval"}
                                      {customer?.customer_status === "2" && "Active"}
                                      {customer?.customer_status === "3" && "Rejected"}
                                      {customer?.customer_status === "4" && "Closed"}
                                    </span>
                                  </td>
                                  <td>{customer.first_name} {customer.last_name}</td>
                                  <td className="text-capitalize">{customer.gender}</td>
                                  <td>{customer.customer_type}</td>
                                  <td>{customer.customer_uuid}</td>
                                  <td>{customer.state_of_origin}</td>
                                  <td>{customer.phone_number}</td>
                                  <td>{new Date(customer.created_at).toISOString().split('T')[0]}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>
                    )}
                    {(isLoading) && (
                        <div
                            className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                            style={{ height: "100%" }}
                        >
                            <div className='mx-auto'>
                            <BounceLoader
                                color='#090b8f'
                                loading={true}
                                // cssOverride={override}
                                size={50}
                                aria-label='Loading Spinner'
                                data-testid='loader'
                                className='ms-3'
                            />
                            <span className='fw-bolder text-primary-1 ms-2'>
                                Please wait...
                            </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

      <ModalContainer modal_id="transfer" modal_width="modal-md" bradius="rounded-2">
        <TransferCustomer customers={selectedIds} setCustomers={setSelectedIds} state={state.id} office_id={state.office_id} />
      </ModalContainer>
    </div>
  );
};

export default AgentCustomers;
